<template>
  <page-wrapper :title="title" :hasPad="true">
    <div class="wrapper">
      <collection-editor
        class="mb-4"
        v-model="form"
        :imageUrl="imageUrl"
      ></collection-editor>
      <div class="text-right">
        <sc-button variant="primary" @click="handleClickSave">บันทึก</sc-button>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import CollectionEditor from "../components/CollectionEditor";
import { baanRueJaiClient } from "@/dependencies";
import { uploadPublicImage } from "@/god";

export default {
  components: {
    PageWrapper,
    ScButton,
    CollectionEditor
  },
  data() {
    const title = "เพิ่มแพ็กเกจใหญ่";
    const form = {
      name: "",
      packages: [],
      imageFile: null
    };

    const imageUrl = null;

    return {
      title,
      form,
      imageUrl
    };
  },
  watch: {
    form(form, oldForm) {
      if (this.form.imageFile === oldForm.imageFile) {
        return;
      }

      this.imageUrl = URL.createObjectURL(this.form.imageFile);
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {},
    async handleClickSave() {
      try {
        await this.createCollection();
        this.$router.push({ name: "CollectionListPage" });
      } catch (err) {
        alert("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
        console.error(err);
      }
    },
    async createCollection() {
      const { name, packages, imageFile } = this.form;
      const image = await uploadPublicImage(imageFile);

      const packageIds = packages.map(({ id }) => id);
      const type = "NORMAL";
      const description = "";

      const params = {
        name,
        packageIds,
        type,
        description,
        image
      };

      const response = await baanRueJaiClient.admin.subscriptions.collections.post(
        params
      );

      return response.data.result;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0;
}

.editor {
  margin-bottom: $space;
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/collections/pages/CollectionCreatePage.vue